/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";

export interface HandleStripeWebhookRequest {
    body?: string;
}

/**
 *
 */
export class StripeWebhookHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Handle Stripe webhook events.
     */
    async handleStripeWebhookRaw(
        requestParameters: HandleStripeWebhookRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/stripe/webhook`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters["body"] as any,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get("content-type"))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Handle Stripe webhook events.
     */
    async handleStripeWebhook(
        requestParameters: HandleStripeWebhookRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<string> {
        const response = await this.handleStripeWebhookRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
